"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAgGridLicense = void 0;

var _core = require("@ag-grid-community/core");

var _core2 = require("@ag-grid-enterprise/core");

var _columnToolPanel = require("@ag-grid-enterprise/column-tool-panel");

var _serverSideRowModel = require("@ag-grid-enterprise/server-side-row-model");

var _clientSideRowModel = require("@ag-grid-community/client-side-row-model");

var _infiniteRowModel = require("@ag-grid-community/infinite-row-model");

var _csvExport = require("@ag-grid-community/csv-export");

/* eslint-disable no-misleading-character-class */
var setAgGridLicense = function setAgGridLicense() {
  // we need to explicitly register required ag-grid modules to keep the bundle size small
  _core.ModuleRegistry.registerModules([_columnToolPanel.ColumnsToolPanelModule, _serverSideRowModel.ServerSideRowModelModule, _clientSideRowModel.ClientSideRowModelModule, _infiniteRowModel.InfiniteRowModelModule, _csvExport.CsvExportModule]);

  _core2.LicenseManager.setLicenseKey('Endurance_International_Group_MULTI_Multiple_Applications_5_Devs_6_Deployment_Licenses_17_December_2020_[v2]_MTYwODE2MzIwMDAwMA==7c47be4cd7450496f0783db9158b581e');
};

exports.setAgGridLicense = setAgGridLicense;